import React, { Component } from "react";
import StaticForm from "../StaticForm/StaticForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : StaticPage
Description : Componente que contienen el formulario de la pantalla StaticPage 
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina – Se llama al componente StaticForm
================================================================================ */
class StaticPage extends Component{
    render(){
        return(
            <div>                    
                <StaticForm/>
            </div>
        )   
    }
}

export default StaticPage;